import React from 'react';

import './Input.css';

interface InputProps {
  type?: 'text' | 'email' | 'password' | 'number' | 'tel';
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  className?: string;
  autoCapitalize?: 'off' | 'on' | 'sentences' | 'words' | 'characters';
  autoComplete?: string;
  inputMode?: 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';
  pattern?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
}

const Input: React.FC<InputProps> = ({
  type = 'text',
  value,
  onChange,
  label,
  placeholder,
  required = false,
  error,
  className = '',
  autoCapitalize,
  autoComplete,
  inputMode,
  pattern,
  disabled = false,
  id,
  name,
}) => {
  return (
    <div className={`input-group ${className}`.trim()}>
      {label ? <label className="input-label">{label}</label> : null}
      <input
        id={id}
        name={name}
        className={`input-field ${error ? 'input-field-error' : ''}`.trim()}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoCapitalize={autoCapitalize}
        autoComplete={autoComplete}
        inputMode={inputMode}
        pattern={pattern}
        disabled={disabled}
      />
      {error ? <div className="input-error-message">{error}</div> : null}
    </div>
  );
};

export default Input;
